import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SubscriptionService} from "../../../../services/subscription.service";
import {StripeCardNumberComponent, StripeService} from "ngx-stripe";
import {BehaviorSubject} from "rxjs";
import {StripeCardElementOptions, StripeElementsOptions} from "@stripe/stripe-js";

@Component({
  selector: 'app-update-payment-modal',
  templateUrl: './update-payment-modal.component.html',
  styleUrls: ['./update-payment-modal.component.scss']
})
export class UpdatePaymentModalComponent implements OnInit {

  subscriptionForm: FormGroup;
  isLoading$: BehaviorSubject<boolean>;
  isProcessing$: BehaviorSubject<boolean>;
  error$: BehaviorSubject<string>;

  @ViewChild(StripeCardNumberComponent) card: StripeCardNumberComponent;

  cardCVCError: string | null;
  cardExpiryError: string | null;
  cardNumberError: string | null;

  cardOptions: StripeCardElementOptions = {
    classes:{
      base: 'form-control form-control-solid',
      complete: 'is-valid',
      invalid: 'is-invalid'
    }
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };

  constructor(
    public subscriptionService: SubscriptionService,
    public stripe: StripeService,
    public fb: FormBuilder
  ) {
    this.isLoading$ = new BehaviorSubject<boolean>(true);
    this.isProcessing$ = new BehaviorSubject<boolean>(false);
    this.error$ = new BehaviorSubject<string>('');
    this.subscriptionForm = this.fb.group({
      nameOnCard: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
  }


  onChange(event: any, type: string){

    switch (type){

      case 'card-number':

        if(event.error){
          this.cardNumberError = event.error.message;
        }else{
          this.cardNumberError = null;
        }

        break;

      case 'card-expiry':

        if(event.error){
          this.cardExpiryError = event.error.message;
        }else{
          this.cardExpiryError = null;
        }

        break;

      case 'card-cvc':

        if(event.error){
          this.cardCVCError = event.error.message;
        }else{
          this.cardCVCError = null;
        }

        break;

    }

  }

  cardFormValid(){

    return !this.cardCVCError && !this.cardNumberError && !this.cardExpiryError && this.subscriptionForm.controls['nameOnCard'].valid

  }

  updatePaymentMethod(){

    this.isProcessing$.next(true);
    this.subscriptionService.createSetupIntent().then( (SetupIntentCreateResult) => {

      this.stripe.confirmCardSetup(SetupIntentCreateResult.client_secret, {
        payment_method: {
          card: this.card.element,
        }
      }).subscribe((ConfirmSetupIntentResult) => {

        if (ConfirmSetupIntentResult.error) {
          // TODO HANDLE ERROR FOR STRIPE SETUP INTENT CONFIRMATION
          this.isProcessing$.next(false);
        }else{
          if(ConfirmSetupIntentResult.setupIntent && ConfirmSetupIntentResult.setupIntent.payment_method){

            this.subscriptionService.updatePaymentMethod(ConfirmSetupIntentResult.setupIntent.payment_method as string).then((UpdatePaymentResult) => {
              this.isProcessing$.next(false);
            }).catch((UpdatePaymentError)=>{
              // TODO HANDLE UPDATE PAYMENT METHOD ERROR (LARAVEL)
              this.isProcessing$.next(false);
            });

          }

        }

      });

    }).catch((SetupIntentCreateError)=>{
      // TODO HANDLE ERROR FOR STRIPE SETUP INTENT CREATION
      this.isProcessing$.next(false);
    });


  }

}
